import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {EmptyCartSetFocusComponent} from './empty-cart-set-focus.component';
import {ConfigModule} from '@spartacus/core';


@NgModule({
  declarations: [EmptyCartSetFocusComponent],
  imports: [
    CommonModule,
    ConfigModule.withConfig({
      cmsComponents: {
        EmptyCartSetFocusComponent: {
          component: EmptyCartSetFocusComponent
        }
      }
    }),
  ]
})
export class EmptyCartSetFocusModule {
}
